/**
 * Papier Royal — Fil natif (remplace Customily sur les carnets cover/fil).
 *
 * Pour chaque <pr-fil-picker> :
 *  - properties[Fil] (le <select>) est DANS le <form> ATC → soumis nativement avec l'id de
 *    variante (cover). Fusion panier native par (variant_id + properties[Fil]) : chaque couple
 *    cover×fil = sa propre ligne. On ne contourne rien (pas de merge/dedup manuel).
 *  - Fil OBLIGATOIRE : bouton(s) ATC désactivé(s) tant qu'aucun fil ; submit bloqué + message si
 *    tentative sans fil. Aucune valeur par défaut silencieuse.
 *  - L'atelier voit la couleur directement : la valeur de Fil est visible en admin commande et
 *    « Fil : X » s'affiche au panier/checkout. Pas de code atelier, pas de propriété cachée.
 *
 * REPORTING FIL (online only) — agrégation par valeur de `Fil`, pondérée par la quantité :
 *   Admin API (GraphQL) :
 *     orders(query:"channel:'online store'"){ nodes{ lineItems{ nodes{
 *       quantity customAttributes{ key value } } } } }
 *   → pour chaque lineItem, prendre l'attribut key=="Fil"; sommer `quantity` par value.
 *   OU export CSV admin : colonne "Lineitem properties" = "Fil: X" ; grouper par X pondéré par
 *   "Lineitem quantity".
 */
(function () {
  'use strict';

  function initPicker(picker) {
    if (picker.__prFilInit) return;
    picker.__prFilInit = true;

    var formId = picker.getAttribute('data-form');
    var form = formId ? document.getElementById(formId) : null;
    if (!form) form = picker.closest('form') || (picker.closest('product-form-component') || document).querySelector('form');
    if (!form) return;

    var select = picker.querySelector('[data-pr-fil-select]');
    var errorEl = picker.querySelector('[data-pr-fil-error]');
    if (!select) return;

    // TOUS les boutons ATC du form (desktop + sticky mobile), pas les boutons de paiement accéléré.
    function atcButtons() {
      return form.querySelectorAll('.add-to-cart-button, button[name="add"], [ref="addToCartButton"]');
    }
    function currentFil() { return (select.value || '').trim(); }

    function updateAtc() {
      var ok = !!currentFil();
      atcButtons().forEach(function (btn) {
        btn.disabled = !ok;
        btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
        btn.classList.toggle('pr-fil-locked', !ok);
      });
    }
    function hideError() { if (errorEl) errorEl.classList.add('hidden'); }
    function showError() { if (errorEl) errorEl.classList.remove('hidden'); }

    // Référence EN canonique : suit la sélection pour un reporting stable quelle que soit la langue.
    var refInput = picker.querySelector('[data-pr-fil-ref]');
    function syncRef() {
      if (!refInput) return;
      var opt = select.options[select.selectedIndex];
      refInput.value = (opt && opt.getAttribute('data-en')) || '';
    }

    select.addEventListener('change', function () { hideError(); updateAtc(); syncTrigger(); syncRef(); });

    // ——— Dropdown custom à swatches (synchronise le <select> caché = source de vérité) ———
    var dd = picker.querySelector('[data-pr-fil-dd]');
    var trigger = picker.querySelector('[data-pr-fil-trigger]');
    var panel = picker.querySelector('[data-pr-fil-panel]');
    var triggerSw = picker.querySelector('[data-pr-fil-trigger-sw]');
    var triggerLabel = picker.querySelector('[data-pr-fil-trigger-label]');
    var opts = picker.querySelectorAll('[data-pr-fil-opt]');

    function syncTrigger() {
      // Reflète l'état du <select> sur le bouton + l'option active (robuste si la valeur change ailleurs).
      var val = select.value || '';
      var active = null;
      opts.forEach(function (o) {
        var on = o.getAttribute('data-value') === val && val !== '';
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) active = o;
      });
      if (triggerSw && triggerLabel) {
        if (active) {
          var hex = active.getAttribute('data-hex');
          triggerLabel.textContent = active.getAttribute('data-label');
          triggerSw.hidden = false;
          triggerSw.classList.toggle('pr-fil__sw--multi', hex === 'multi');
          triggerSw.style.background = hex === 'multi' ? '' : hex;
        }
      }
    }

    if (trigger && panel) {
      var openPanel = function () {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        var sel = panel.querySelector('[aria-selected="true"]');
        if (sel) { try { sel.scrollIntoView({ block: 'nearest' }); } catch (e) {} }
      };
      var closePanel = function () {
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      };
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (panel.hidden) openPanel(); else closePanel();
      });
      opts.forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.preventDefault();
          select.value = opt.getAttribute('data-value');
          select.dispatchEvent(new Event('change', { bubbles: true })); // → hideError + updateAtc + syncTrigger
          closePanel();
          try { trigger.focus(); } catch (err) {}
        });
      });
      document.addEventListener('click', function (e) {
        if (!panel.hidden && dd && !dd.contains(e.target)) closePanel();
      });
      picker.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) { closePanel(); try { trigger.focus(); } catch (err) {} }
      });
      syncTrigger(); // état initial (au cas où le select a déjà une valeur)
    }

    // Garde dure : bloque le submit sans fil (backstop si un chemin d'ATC contourne le bouton désactivé).
    form.addEventListener(
      'submit',
      function (e) {
        if (!currentFil()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError();
          try { select.focus(); } catch (err) {}
        }
      },
      true // capture : passe avant le handler du product-form-component
    );

    updateAtc(); // état initial : ATC désactivé (fil vide)

    // Le product-form-component ré-active les boutons à l'hydratation. On ré-affirme le verrou
    // visuel un nombre BORNÉ de fois après le chargement (pas d'observer vivant : sur mobile, la
    // barre ATC sticky re-synchronise l'état du bouton en continu → un observer qui ré-désactive
    // à chaque mutation entrait en ping-pong avec le thème et FIGEAIT le thread. Cf. freeze mobile
    // carnet japonais 2026-07-30). La validation DURE ne dépend PAS de ce verrou : le <select>
    // `required` + la garde submit ci-dessus empêchent nativement tout ajout sans fil.
    [80, 250, 600, 1200].forEach(function (ms) {
      setTimeout(function () { if (!currentFil()) updateAtc(); }, ms);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('pr-fil-picker').forEach(initPicker);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();